<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="otro-pago?tipos_movimientos_id=2&personas_id={{persona}}" titulo="Venta"></app-listar>
<a id="nohacer"></a>
<!-- Menu principal "-->

<div class="contenedor columns " style="height:100%; ">
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->

            <div id="exportar_datos" class="columns">
              <div class="column is-12">
                <a id="imprimirTicket" (click)="ctrl.imprimeTicket(ctrl.json)"></a>
                <a id="cargarLista" (click)="ctrl.actualizarUrl('otro-pago?tipos_movimientos_id=2&personas_id=' + persona)"></a>

                <div class="tile is-ancestor" style="max-width: 89vw; display: contents;">
                  <div class="tile is-parent is-3" *ngFor="let item of ctrl.dato; let i=index" style="float: left">
                    <div class="tile is-child box" align="center">
                      <p class="subtitle">{{item.codigo}}</p>
                      <p class="subtitle">{{item.created_at}}</p>

                      <span class="tag is-black" *ngFor="let art of item.movimientos_articulos">{{ art.articulos.nombre }}&nbsp; &nbsp;<span class="tag is-small is-success">{{art.precio_con_descuentos | currency:ctrl.configuracion.sucursal.moneda:'symbol' }}</span></span>

                      <a class="button navbar-item tooltip is-fullwidth"  style="width: 50%; float: left;" [ngClass]="{'is-loading': ctrl.imprimir_cargando && ctrl.contador == index}"
                        (click)="ctrl.imprimir(item, i)">
                        <span class="icon fa-2x has-text-link">
                          <i class="icon-printer2"></i>
                        </span>
                        <span class="tooltiptext">Imprimir</span>
                      </a>

                      <a class="button navbar-item tooltip is-fullwidth"  style="width: 50%; float: left;" [ngClass]="{'is-loading': ctrl.imprimir_cargando && ctrl.contador == index}"
                      (click)="imprimir(item, i)">
                      <span class="icon fa-2x has-text-link">
                        <i class="icon-email3"></i>
                      </span>
                      <span class="tooltiptext">Enviar Ticket</span>
                    </a>

                      <a class="button navbar-item tooltip is-fullwidth"  style="width: 50%; float: left;" (click)="ctrl.imprimeFactura(item.factura, logo)" *ngIf="item.factura"
                        style="width: 50%; float: left;">
                        <span class="icon fa-2x">
                          <i class="icon-print"></i>
                        </span>
                        <span class="tooltiptext is-hidden-touch">&nbsp; Imprimir Factura</span>
                      </a>

                      <a (click)="calcular_importe_articulo(item, ctrl.json)" id="funcion_secundaria{{i}}"></a>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Paginación para la lista  -->
            <div class="columns">
              <div class="column is-12">
                <app-paginacion [ctrl]="ctrl"></app-paginacion>
              </div>
            </div>
        </div>

    </div>
</div>

<div style="display:none" id="imprimir">
    <div dir="ltr" *ngIf="ctrl.json">
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="center">
            <font >
                {{ctrl.configuracion.empresa.nombre}}</font>
        </p>
        <p align="center">
            <font >
                {{ctrl.configuracion.empresa.direccion}}
            </font>
        </p>
        <p align="center" style="font-weight:normal">
            <br>
        </p>
        <hr style="border:2px dashed black;width:100%">
        <p align="center" style="font-style:normal;font-weight:normal">
            <font >{{ctrl.configuracion.sucursal.nombre}}
            </font>
        </p>
        <p align="center" style="font-style:normal;font-weight:normal">
            <font >{{ctrl.configuracion.sucursal.direccion}}</font>
        </p>
        <p align="center" style="font-style:normal;font-weight:normal">
            <font >Tel: {{ctrl.configuracion.sucursal.telefono}} Correo: {{ctrl.configuracion.sucursal.correo}}</font>
        </p>
        <hr style="border:2px dashed black;width:100%">
        <p align="left"> </p>


        <p align="right">
            <font >
                <span style="font-weight:normal">CODIGO : {{ctrl.json.codigo}}</span>
                <b> </b>
            </font>
        </p>

        <p align="right" style="font-weight:normal">
            <font >
                <span style="font-weight:normal">FECHA : </span>
                <b>{{ctrl.json.created_at | formatoFecha}} </b>
            </font>
        </p>

        <p align="right" style="font-weight:normal" *ngIf="ctrl.json.personas">
            <font >
                <span style="font-weight:normal">CLIENTE : </span>
                <b>{{ctrl.json.personas.nombre}} </b>
            </font>
        </p>

        <hr style="border:2px dashed black;width:100%">
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <font >
                <b>VENTA</b>
            </font>
        </p>

        <p align="left">
            <br>
        </p>
        <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
            <tr valign="top">
                <td width="25%" style="border:none;padding:0cm">
                    CANT.
                </td>
                <td width="25%" style="border:none;padding:0cm">
                    PRECIO
                </td>
                <td width="25%" style="border:none;padding:0cm">
                    DESCUENTO
                </td>
                <td width="25%" style="border:none;padding:0cm">
                    IMPORTE
                </td>
            </tr>
        </table>
        <div *ngFor="let item of ctrl.json.movimientos_articulos">
            <strong>({{item.articulos.clave}}) {{item.articulos.nombre}}</strong>
            <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
                <tr valign="top">
                    <td width="25%">{{item.cantidad}}</td>

                    <td width="25%">{{item.precio_unitario}}</td>
                    <td width="25%">{{item.descuento}}%</td>
                    <td width="25%">{{item.precio_con_descuentos | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</td>
                </tr>
            </table>
            <hr style="padding:0px; margin:0px;">
        </div>
        <div *ngIf="ctrl.json.devoluciones.length > 0">
            <p align="center" style="margin-bottom:0cm;line-height:100%">
                <font>
                    <b>DEVOLUCIÓN</b>
                </font>
            </p>

            <p align="left">
                <br>
            </p>


            <div *ngFor="let dev of ctrl.json.devoluciones">

                <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
                    <tr valign="top">
                        <td width="25%" style="border:none;padding:0cm">
                            CANT.
                        </td>
                        <td width="25%" style="border:none;padding:0cm">
                            PRECIO
                        </td>
                        <td width="25%" style="border:none;padding:0cm">
                            DESCUENTO
                        </td>
                        <td width="25%" style="border:none;padding:0cm">
                            IMPORTE
                        </td>
                    </tr>
                </table>
                <div *ngFor="let item of dev.movimientos.movimientos_articulos">
                    <strong>({{item.articulos.clave}}) {{item.articulos.nombre}}</strong>
                    <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
                        <tr valign="top">
                            <td width="25%">{{item.cantidad}}</td>

                            <td width="25%">{{item.precio_unitario}}</td>
                            <td width="25%">{{item.descuento}}%</td>
                            <td width="25%">{{item.precio_con_descuentos | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</td>
                        </tr>
                    </table>
                    <hr style="padding:0px; margin:0px;">
                </div>
            </div>
        </div>
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>

        <div>
            <p align="right" style="font-weight:normal">
                <strong>
                    <font>SUBTOTAL</font>

                </strong>
                <font>
                    {{ctrl.json.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div *ngIf="ctrl.json.descuento > 0">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font>Descuento</font>

                </strong>
                <font>
                    {{ctrl.json.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div>
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >TOTAL</font>

                </strong>
                <font >
                    {{ctrl.json.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >{{moneda.nombre}}</font>

                </strong>
                <font >
                    {{(ctrl.json.total / moneda.tipo_cambio) | currency:moneda.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div *ngFor="let p of ctrl.json.pagos">
            <p align="right" style="font-weight:normal">
                <strong>
                    {{p.tipos_formas_pagos.nombre }}
                </strong>
                <font>
                    {{p.importe | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
            <p align="right" style="font-weight:normal">
                <font>
                    {{p.tipos_metodos_pagos.nombre }}
                </font>
            </p>
            <hr style="border:1px dashed black;width:100%">
        </div>
        <div *ngIf="ctrl.json.cambio">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >CAMBIO</font>

                </strong>
                <font >
                    {{ctrl.json.cambio | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
            <div *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas">
                <p align="right" style="font-weight:normal">
                    <strong>
                        <font >{{moneda.nombre}}</font>

                    </strong>
                    <font >
                        {{(ctrl.json.cambio / moneda.tipo_cambio) | currency:moneda.moneda:'symbol'}}
                    </font>
                </p>
            </div>
        </div>

        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="left">
            <font>
                <span style="font-weight:normal">
                    ATENDIÓ :
                </span>
                <span style="font-weight:normal">
                    {{ctrl.json.usuarios.nombre}}
                </span>
            </font>
        </p>
        <p align="center" style="font-weight:normal">
            <font>
                Gracias por su compra
            </font>
        </p>
        <p align="center">
            <img [src]="'data:image/png;base64,' + ctrl.json.barcode">
        </p>
    </div>
</div>
